module.exports = __webpack_public_path__ + "ai.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ai.svg
// module id = 667
// module chunks = 0